<!-- search bar -->
<div class="content-wrap">
    <div class="container">
        <div class="breadcrumb">
            <app-bread-crumb [data]="breadCrumb"></app-bread-crumb>
        </div>
        <div class="title-catalogue d-flex justify-content-between align-items-center">
            <h2>{{ 'IRONSIDE.supplier-list.suppliers' | translate }}</h2>
        </div>
        <div class="d-flex justify-content-between align-items-center mb-3 flex-wrap">
            <div class="search-fournisseurs d-flex">
                <div class="wrap-input d-flex">
                    <label class="mb-0" for="">{{
                        'IRONSIDE.supplier-list.company-name' | translate
                    }}</label>
                    <input
                        type="text"
                        (focusout)="emptyList()"
                        placeholder="{{ 'IRONSIDE.supplier-list.search-supplier' | translate }}"
                        [(ngModel)]="companyName"
                        (input)="onSearchInput()"
                        (keyup)="onKeyUp($event)"
                    />
                </div>
                <button (click)="getListSuppliers()"><i class="pi pi-search"></i></button>
                <div class="autocomplete-list" *ngIf="autocompleteSearchlistSuppliers.length > 0">
                    <ul class="p-0" style="list-style: none">
                        <li
                            class="ac-li"
                            *ngFor="let item of autocompleteSearchlistSuppliers"
                            (click)="selectItem(item)"
                        >
                            {{ item.title }}
                        </li>
                    </ul>
                </div>
            </div>
            <div
                class="export"
                *ngIf="permissionService.isPermissionFonction('export-donnees-fournisseurs')"
            >
                <button
                    class="btn-common"
                    [disabled]="loadingExport"
                    (click)="onExporterFournisseur()"
                >
                    <span class="btn-export"
                        >{{ 'IRONSIDE.supplier-list.export' | translate }}
                        <mat-spinner *ngIf="loadingExport" [diameter]="15"></mat-spinner
                    ></span>
                </button>
            </div>
        </div>
    </div>
</div>
<div class="list-fournisseur">
    <ng-container *ngIf="loading">
        <div class="secsion-loading">
            <mat-spinner [diameter]="50"></mat-spinner>
        </div>
    </ng-container>
    <div class="container">
        <div class="col-12 p-0 pl-3">
            <form class="">
                <div class="wrap-pagination">
                    <div class="d-flex justify-content-between align-items-center mb-3">
                        <div class="wrap-rows">
                            {{ 'IRONSIDE.supplier-list.show' | translate }}
                            <p-dropdown
                                [(ngModel)]="pageSize"
                                (ngModelChange)="getListSuppliers()"
                                class="item-page"
                                [options]="listRows"
                                optionLabel=""
                            ></p-dropdown
                            >{{ 'IRONSIDE.supplier-list.elements' | translate }}
                        </div>
                        <p-paginator
                            *ngIf="listSuppliers"
                            (onPageChange)="onPageChange3($event)"
                            [first]="first"
                            [rows]="pageSize"
                            [totalRecords]="totalRecords"
                            [showFirstLastIcon]="false"
                            [showCurrentPageReport]="false"
                        ></p-paginator>
                    </div>
                </div>
            </form>
            <div class="product-content d-flex align-items-center flex-wrap flex-col">
                <div
                    #lazyItem
                    [attr.data-lazyId]="supplier?.id"
                    *ngFor="let supplier of listSuppliers"
                    class="fournisseur-item d-flex align-items-center"
                >
                    <div style="display: flex; gap: 6px; width: 100%">
                        <div class="logo-fournisseur w-50 p-10">
                            <img
                                [src]="
                                    supplier?.logo
                                        ? supplier?.logo
                                        : 'src-ironside/assets/images/image-default.jpg'
                                "
                                alt=""
                            />
                        </div>
                        <div class="fournisseur-body w-50">
                            <h3 class="mb-1">{{ supplier?.title }}</h3>
                            <!-- <span *ngIf="supplier?.phone"
                                ><strong>{{ 'IRONSIDE.supplier-list.phone' | translate }} : </strong
                                >{{ supplier?.phone }}</span
                            >
                            <span *ngIf="supplier?.fax"
                                ><strong>{{ 'IRONSIDE.supplier-list.fax' | translate }} : </strong
                                >{{ supplier?.fax }}</span
                            >
                            <span *ngIf="supplier?.email"
                                ><strong>{{ 'IRONSIDE.supplier-list.email' | translate }} : </strong
                                >{{ supplier?.email }}</span
                            > -->
                            <!-- <span *ngIf="supplier?.city"
                                ><strong>{{ 'IRONSIDE.supplier-list.city' | translate }} : </strong
                                >{{ supplier?.city }}</span
                            > -->
                        </div>
                    </div>
                    <div class="action">
                        <button (click)="goSupplierDetail(supplier)" class="btn-common">
                            {{ 'IRONSIDE.partner-list.view-details' | translate }}
                        </button>
                        <button (click)="goCatalogue(supplier)" class="btn-common">
                            {{ 'IRONSIDE.supplier-list.catalog' | translate }}
                        </button>
                    </div>
                </div>
            </div>
            <form class="">
                <div class="wrap-pagination">
                    <div class="d-flex justify-content-between align-items-center mb-3">
                        <div class="wrap-rows">
                            {{ 'IRONSIDE.supplier-list.show' | translate }}
                            <p-dropdown
                                [(ngModel)]="pageSize"
                                (ngModelChange)="getListSuppliers()"
                                class="item-page"
                                [options]="listRows"
                                optionLabel=""
                            ></p-dropdown
                            >{{ 'IRONSIDE.supplier-list.elements' | translate }}
                        </div>
                        <p-paginator
                            *ngIf="listSuppliers"
                            (onPageChange)="onPageChange3($event)"
                            [first]="first"
                            [rows]="pageSize"
                            [totalRecords]="totalRecords"
                            [showFirstLastIcon]="false"
                            [showCurrentPageReport]="false"
                        ></p-paginator>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
